import React from 'react'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

const FilterAlert = () => {
    return (
        <div className={'emp-filterAlert-root'} style={{ fontSize: '14px' }}>
            <FontAwesomeIcon icon={faExclamationTriangle} color='red' size='sm'/>
            <Typography className={'emp-filterAlert-text'} style={{ fontSize: '12px', fontWeight: '600' }}>
                Filter Currently Applied in Advanced Search
            </Typography>
        </div>
    )
}

export default FilterAlert
